__turbopack_context__.v({
  "caption": "KpiCard-module__Tnx0za__caption",
  "colorBlue": "KpiCard-module__Tnx0za__colorBlue",
  "colorNeutral": "KpiCard-module__Tnx0za__colorNeutral",
  "colorOrange": "KpiCard-module__Tnx0za__colorOrange",
  "colorPink": "KpiCard-module__Tnx0za__colorPink",
  "compareLabel": "KpiCard-module__Tnx0za__compareLabel",
  "delta": "KpiCard-module__Tnx0za__delta",
  "deltaDown": "KpiCard-module__Tnx0za__deltaDown",
  "deltaFlat": "KpiCard-module__Tnx0za__deltaFlat",
  "deltaUp": "KpiCard-module__Tnx0za__deltaUp",
  "empty": "KpiCard-module__Tnx0za__empty",
  "goalPill": "KpiCard-module__Tnx0za__goalPill",
  "goalPillFar": "KpiCard-module__Tnx0za__goalPillFar",
  "goalPillMet": "KpiCard-module__Tnx0za__goalPillMet",
  "goalPillNear": "KpiCard-module__Tnx0za__goalPillNear",
  "root": "KpiCard-module__Tnx0za__root",
  "sparklineWrap": "KpiCard-module__Tnx0za__sparklineWrap",
  "unit": "KpiCard-module__Tnx0za__unit",
  "value": "KpiCard-module__Tnx0za__value",
  "valueRow": "KpiCard-module__Tnx0za__valueRow",
});
